// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","empty":"Layout_empty__zJans","contentWrapper":"Layout_contentWrapper__j8i0M","content":"Layout_content__UOgH6","page":"Layout_page__p6SrX"};